export enum Paths {
    main = '/',
    oneCZupRoles = '/onec-zup-roles',
    iikoRoles = '/iiko-roles',
    oneCZupDepartments = '/onec-zup-departments',
    iikoDepartments = '/iiko-departments',
    iSpringDepartments = '/ispring-departments',
    employees = '/employees',
}